<div *ngIf="show" class="spinner-wrapper">
    <i class="fa fa-spinner fa-spin"></i>

    <div *ngIf="title" class="text-wrapper">
        <div class="title">{{title}}</div>
        <div class="body">{{body}}</div>
    </div>
</div>